import React, { useEffect } from "react";
import styled from "styled-components";
import NavigationHeader from "../../organisms/NavigationHeader";
import { log, LogLevel } from "utils/LogUtil";

interface LandingTemplateProps {
  onLogin: () => void;
  onChat: () => void;
  externalUrl: string;
}

const LandingTemplate: React.FC<LandingTemplateProps> = ({
  onLogin,
  onChat,
  externalUrl,
}) => {
  // iframe에서 보내는 메시지 수신
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      // 보안: 신뢰할 수 있는 origin인지 확인
      const allowedOrigins = [
        "https://phai.framer.website",
        ...(process.env.NODE_ENV === "development" ? ["http://localhost:3000"] : [])
      ];

      if (!allowedOrigins.includes(event.origin)) {
        log(LogLevel.VERBOSE, "[LandingTemplate] 신뢰할 수 없는 origin에서 메시지 수신:", event.origin);
        return;
      }

      log(LogLevel.INFO, "[LandingTemplate] iframe 메시지 수신:", event.data);

      // 메시지 타입에 따라 처리
      if (event.data?.type === "LOGIN_BUTTON_CLICKED") {
        log(LogLevel.INFO, "[LandingTemplate] iframe에서 로그인 버튼 클릭됨");
        onLogin();
      } else if (event.data?.type === "CHAT_BUTTON_CLICKED") {
        log(LogLevel.INFO, "[LandingTemplate] iframe에서 채팅 버튼 클릭됨");
        onChat();
      }
    };

    window.addEventListener("message", handleMessage);

    // cleanup
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [onLogin, onChat]);

  return (
    <Container>
      <NavigationHeader onLogin={onLogin} />
      <IframeContainer>
        <StyledIframe
          src={externalUrl}
          title="PhAI 소개"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        />
      </IframeContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const IframeContainer = styled.div`
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export default LandingTemplate;
